import { WidgetVisibilityConditionOperator } from '~/graphql/types';
import { WidgetVisibilityRulesFragment } from '~/graphql/types';
import { assertNeverWithoutThrowing } from '~/util/assertion';

export type VisibilityRuleValidationError = {
  ruleIndex: number;
  conditionIndex?: number;
  message: string;
};

function isValidRegex(value: string): boolean {
  if (value === '') return false;
  try {
    new RegExp(value);
    return true;
  } catch {
    return false;
  }
}

export function validateVisibilityRules(
  visibilityRules: WidgetVisibilityRulesFragment,
): Array<VisibilityRuleValidationError> {
  const errors: Array<VisibilityRuleValidationError> = [];

  visibilityRules.rules.forEach((rule, ruleIndex) => {
    if (!rule.conditions?.length) {
      errors.push({
        ruleIndex,
        message: 'Elke regel moet minimaal één voorwaarde hebben.',
      });
      return;
    }

    rule.conditions.forEach((condition, conditionIndex) => {
      const value = condition.value?.trim() ?? '';

      switch (condition.operator) {
        case WidgetVisibilityConditionOperator.Contains:
        case WidgetVisibilityConditionOperator.EndsWith:
        case WidgetVisibilityConditionOperator.NotContains:
        case WidgetVisibilityConditionOperator.NotEndsWith:
        case WidgetVisibilityConditionOperator.NotStartsWith:
        case WidgetVisibilityConditionOperator.StartsWith:
          if (value === '') {
            errors.push({
              ruleIndex,
              conditionIndex,
              message: 'Waarde is verplicht.',
            });
          }
          break;
        case WidgetVisibilityConditionOperator.NotRegex:
        case WidgetVisibilityConditionOperator.Regex:
          if (!isValidRegex(value)) {
            errors.push({
              ruleIndex,
              conditionIndex,
              message: 'Ongeldige reguliere expressie.',
            });
          }
          break;
        case WidgetVisibilityConditionOperator.NotEquals:
        case WidgetVisibilityConditionOperator.Equals:
          break;
        default:
          assertNeverWithoutThrowing(condition.operator);
      }
    });
  });

  return errors;
}
